import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload, requestSaga } from "shared-utility/store/utils/helpers";

export const GET_RENT_ROLLS = generateDefaultActions("GET_RENT_ROLLS");
export const getRentRolls = payload => makePayload(GET_RENT_ROLLS.value, payload);
function* getRentRollsSaga({ propertyId, dealId }) {
  const url = `/rent-rolls/property/${dealId}/${propertyId}`;
  yield requestSaga(GET_RENT_ROLLS, url, "GET", null, null, null, true);
}

export const POST_SUITE = generateDefaultActions("POST_SUITE");
export const postSuite = payload => makePayload(POST_SUITE.value, payload);
function* postSuiteSaga({ data }) {
  const url = "/rent-rolls";
  yield requestSaga(POST_SUITE, url, "POST", data, null, null, true);
}

export const PUT_SUITE = generateDefaultActions("PUT_SUITE");
export const putSuite = payload => makePayload(PUT_SUITE.value, payload);
function* putSuiteSaga({ data }) {
  const url = "/rent-rolls";
  yield requestSaga(PUT_SUITE, url, "PUT", data, null, null, true);
}

export const DELETE_SUITE = generateDefaultActions("DELETE_SUITE");
export const deleteSuite = payload => makePayload(DELETE_SUITE.value, payload);
function* deleteSuiteSaga({ id }) {
  const url = `/rent-rolls/${id}`;
  yield requestSaga(DELETE_SUITE, url, "DELETE", null, null, null, true);
}

export const SET_RENT_ROLLS_SELECTIONS = generateDefaultActions("SET_RENT_ROLLS_SELECTIONS");
export const setRentRollsSelections = payload => makeWritePayload(SET_RENT_ROLLS_SELECTIONS.value, payload);

export const SET_RENT_ROLLS_TO_DEFAULT = generateDefaultActions("SET_RENT_ROLLS_TO_DEFAULT");
export const setRentRollsToDefault = payload => makeWritePayload(SET_RENT_ROLLS_TO_DEFAULT.value, payload);

const initialState = {
  allSuites: null,
  isLoading: false,
  selectedSuite: null,
  selectedLease: null,
  selectedChargeSchedule: null,
  isEditingSuite: false,
  isEditingLease: false,
  isEditingChargeSchedule: false,
  shouldRefetchRentRolls: false,
  chargeCodeAliases: null
};

export const actionCreators = {
  getRentRolls,
  postSuite,
  putSuite,
  deleteSuite,
  setRentRollsSelections,
  setRentRollsToDefault
};

export function rentRollsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_RENT_ROLLS.failure:
      return defaultReturn({ ...state, isLoading: false }, null, "allSuites");
    case GET_RENT_ROLLS.success:
      return defaultReturn({ ...state, isLoading: false, shouldRefetchRentRolls: false }, payload, "allSuites");
    case GET_RENT_ROLLS.value:
      return defaultReturn({ ...state, isLoading: true });

    case POST_SUITE.failure:
      ToastError("Failed to add Suite");

      return defaultReturn({ ...state });
    case POST_SUITE.success:
      ToastSuccess("New Suite has been added");

      return defaultReturn({
        ...state,
        isEditingSuite: true,
        selectedSuite: payload.data,
        allSuites: [...state.allSuites, payload.data]
      });
    case POST_SUITE.value:
      return defaultReturn({ ...state });

    case PUT_SUITE.failure:
      ToastError("Failed to update suite");

      return defaultReturn({ ...state });
    case PUT_SUITE.success: {
      ToastSuccess("Suite has been updated");
      const updatedSuites = state.allSuites.map(suite => {
        if (suite.id !== payload.data.id) {
          return suite;
        }

        return payload.data;
      });

      return defaultReturn({ ...state, allSuites: updatedSuites });
    }
    case PUT_SUITE.value:
      return defaultReturn({ ...state });

    case DELETE_SUITE.failure:
      ToastError("Failed to delete suite");

      return defaultReturn({ ...state });
    case DELETE_SUITE.success: {
      const updatedSuites = state.allSuites.filter(suite => suite.id !== payload.data.deletedId);

      return defaultReturn({ ...state, selectedSuite: null, allSuites: updatedSuites });
    }
    case DELETE_SUITE.value:
      return defaultReturn({ ...state });

    case SET_RENT_ROLLS_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });
    case SET_RENT_ROLLS_TO_DEFAULT.value:
      return defaultReturn({ ...initialState });

    default:
      return state;
  }
}

export function* rentRollsSaga() {
  yield takeLatest(GET_RENT_ROLLS.value, getRentRollsSaga);
  yield takeLatest(POST_SUITE.value, postSuiteSaga);
  yield takeLatest(PUT_SUITE.value, putSuiteSaga);
  yield takeLatest(DELETE_SUITE.value, deleteSuiteSaga);
}
